import React from 'react';

// import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
}

const FurniturePanelMobile = ({ children }: Props) => (
  <div className="bg-secondary w-full flex justify-center">{children}</div>
);

export default FurniturePanelMobile;
